module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid13_800x663.2eb21e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid13_800x663.jpg
// module id = 94Z6
// module chunks = 0